// libs
import React, { memo } from "react";
import { css, SerializedStyles } from "@emotion/core";

// components
import WithStyles from "shared/components/WithStyles";

// helpers
import { cssMerge } from "shared/helpers/utils";

// styles
import { resetButton } from "shared/styles/mixin";

const basicCss = css`
    display: flex;
    position: absolute;
    height: 40px;
    width: 100%;
    bottom: 0;
    background: rgba(255, 255, 255, 0.4);
    align-items: center;
    justify-content: center;

    .d-dot {
        ${resetButton}
        height: 10px;
        width: 10px;
        background: #d8d8d8;
        margin-right: 4px;
        cursor: pointer;

        &-active {
            height: 12px;
            width: 12px;
            background: #000;
        }

        &:last-child {
            margin-right: 0;
        }
    }
`;

// def
interface IDotsProps {
    currentSlide: number;
    numberOfSlides: number;
    cssProps?: SerializedStyles | SerializedStyles[];
    onSelect?: (id: number) => void;
    videoSlides?: number[];
}

const IMAGE_NAVIGATION_LABEL_PREFIX = "Navigate Image number ";
const EMPTY_ARRAY: number[] = [];

function Dots({
    currentSlide,
    numberOfSlides,
    cssProps,
    onSelect,
    videoSlides = EMPTY_ARRAY,
}: IDotsProps) {
    if (numberOfSlides < 2) {
        return null;
    }

    const slides = [];
    const dotsCss = cssMerge(basicCss, cssProps);
    const onSelection = (id: number) => {
        onSelect && onSelect(id);
    };

    for (let i = 0; i < numberOfSlides; i++) {
        slides.push(i);
    }

    return (
        <WithStyles cssProps={dotsCss}>
            {slides.map(index => {
                const className = [
                    "d-dot",
                    currentSlide === index && "d-dot-active",
                    videoSlides.includes(index) && "d-dot-video",
                ]
                    .filter(Boolean)
                    .join(" ");

                return (
                    <button
                        aria-label={IMAGE_NAVIGATION_LABEL_PREFIX + index}
                        key={index}
                        className={className}
                        onClick={() => onSelection(index)}
                    />
                );
            })}
        </WithStyles>
    );
}

export default memo(Dots);
